import { isEmpty } from 'lodash';
import React from 'react';
import { TableActionsLinkItem } from './TableActionsLinkItem';

interface DescriptorLinksProps {
  descriptors: any[];
  onLinkClick: (url: string) => void;
  newTableActions: string[];
}

export const TableActionsDescriptorLinks = ({
  descriptors,
  onLinkClick,
  newTableActions,
}: DescriptorLinksProps) => {
  if (isEmpty(descriptors)) {
    return null;
  }
  const filteredDescriptors = isEmpty(newTableActions)
    ? descriptors
    : descriptors.filter((descriptor) => newTableActions.includes(descriptor.id));

  return (
    <div>
      <ul>
        {filteredDescriptors.map((entry, index) => (
          <TableActionsLinkItem entry={entry} key={index} index={index} onLinkClick={onLinkClick} />
        ))}
      </ul>
    </div>
  );
};
